import { CALL_API } from '../../../middlewares/api';

import { updateInfos } from '../../account/actions';
import { forceFetchPartners } from '../../partner/actions';
import { REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN } from './constants';

export const loginUser = (creds, callback) => {
    return {
        [CALL_API]: {
            endpoint: '/auth/login',
            types: [REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN],
            body: creds,
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload.user));
                dispatch(forceFetchPartners());
                if (callback) {
                    callback();
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/login/actions.js